import {
  MERCHANT_PLATFORMS_WITH_MERCHANT_ID_ENABLED,
  MerchantPlatformNames,
} from 'constants/merchantPlatforms';

import { useGetOne } from 'react-admin';
import { MerchantPlatform } from 'types/embedded/merchant';

export function useIsMerchantIdEnabledByDefault(merchantPlatformId?: string): {
  isMerchantIdEnabledByDefault: boolean;
  isLoading: boolean;
} {
  const { data: merchantPlatform, isLoading } = useGetOne<MerchantPlatform>(
    'merchant_platforms',
    { id: merchantPlatformId },
    { enabled: !!merchantPlatformId },
  );

  if (!merchantPlatformId) {
    return { isMerchantIdEnabledByDefault: false, isLoading: false };
  }
  const platformName = merchantPlatform?.name as MerchantPlatformNames;

  const isMerchantIdEnabledByDefault = platformName
    ? MERCHANT_PLATFORMS_WITH_MERCHANT_ID_ENABLED.includes(platformName)
    : false;

  return { isMerchantIdEnabledByDefault, isLoading };
}
